module.exports = __webpack_public_path__ + "static/media/Tooth_icon_007cba.34693f35.svg";